import PropTypes from "prop-types";
import React from "react";

import { Button, Icon } from "@swa-ui/core";
import { classNames } from "@swa-ui/string";

import styles from "./DropdownTrigger.module.scss";

const ICON_ACTIVE_DESIGN_TOKEN = "cmp-core-color-dropdown-icon";
const ICON_INACTIVE_DESIGN_TOKEN = "cmp-core-color-input-fg";

export const DropdownTrigger = (props) => {
  const { isCaptionVisible = false, onTrigger = () => {}, text } = props;

  return (
    <Button className={getDropdownClassNames()} onClick={onTrigger} styleType="no-style">
      {text}
      <Icon {...getIconProps()} />
    </Button>
  );

  function getDropdownClassNames() {
    return classNames({
      [styles.dropdown]: true,
      [styles.dropdownFocus]: isCaptionVisible,
    });
  }

  function getIconProps() {
    return {
      color: isCaptionVisible ? ICON_ACTIVE_DESIGN_TOKEN : ICON_INACTIVE_DESIGN_TOKEN,
      custom: { type: isCaptionVisible ? "inactive" : "active" },
      name: "ArrowThin",
      role: "presentation",
    };
  }
};

DropdownTrigger.propTypes = {
  /** Indicates if the dropdown should be styled as open or closed. */
  isCaptionVisible: PropTypes.bool,

  /** Optional callback to learn when the dropdown is triggered. */
  onTrigger: PropTypes.func,

  /** Text to display inside the dropdown's fake input. */
  text: PropTypes.string.isRequired,
};
